var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWrench = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M21.512 6.112 17.622 10l-3.535-3.536 3.89-3.89a6.501 6.501 0 0 0-8.484 8.486l-6.277 6.276a1 1 0 0 0 0 1.414l2.122 2.122a1 1 0 0 0 1.414 0l6.275-6.276a6.5 6.5 0 0 0 7.071-1.414 6.5 6.5 0 0 0 1.414-7.071Z"
})));
export default SvgWrench;